export default "__VITE_ASSET__3XNwQvfA__"